import React from 'react'
import "./Furniture.css"
import Product from "../Components/Product"
import prd1 from "../images/decor1.webp"
import prd2 from "../images/decor2.webp"
import prd3 from "../images/decor3.webp"
import prd4 from "../images/decor4.webp"
import prd5 from "../images/decor5.webp"
import prd6 from "../images/decor6.webp"
import prd7 from "../images/decor7.webp"
import prd8 from "../images/decor8.webp"
import prd9 from "../images/decor9.webp"
import prd10 from "../images/decor10.webp"
import prd11 from "../images/decor11.webp"
import prd12 from "../images/decor12.webp"
import prd13 from "../images/decor13.webp"
import prd14 from "../images/decor14.webp"
import prd15 from "../images/decor15.webp"
export default function Furniture() {
    return (
        <div>
            <div className="main">

                <div className="prd_row1">
                    <Product id="decor1" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd1} price="Price : ₹10,820 " review="5.5" ></Product>
                    <Product id="decor2" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd2} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="decor3" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd3} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="decor4" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd4} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="decor5" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd5} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="decor6" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd6} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="decor7" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd7} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="decor8" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd8} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                


            </div>
            <div className="main1">

                <div className="prd_row1">
                    <Product id="decor9" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd9} price=" ₹10,820  25% off" review="5.5" ></Product>
                    <Product id="decor10" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd10} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="decor11" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd11} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="decor12" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd12} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="decor13" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd13} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="decor14" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB  " img={prd14} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="decor15" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd15} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="decor16" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd1} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                


            </div>

        </div>
    )
}
